// extracted by mini-css-extract-plugin
export var standaloneTable = "_fd-0";
export var standaloneTableWithBodyFill = "_fd-1";
export var withExtraHeader = "_fd-2";